var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
export var getVideoUrlQuery = function (key, download) {
    if (download === void 0) { download = 0; }
    return ({
        query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query($key: String!, $download: Number) {\n      getUrlRes(key: $key, download: $download)\n        @rest(type: \"VideoUrl\", path: \"/getVideoUrl?key=:key&download=:download\", endpoint: \"query\") {\n        signedUrl\n      }\n    }\n  "], ["\n    query($key: String!, $download: Number) {\n      getUrlRes(key: $key, download: $download)\n        @rest(type: \"VideoUrl\", path: \"/getVideoUrl?key=:key&download=:download\", endpoint: \"query\") {\n        signedUrl\n      }\n    }\n  "]))),
        variables: { key: key, download: download },
    });
};
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/getVideoUrl.ts
// module id = 807
// module chunks = 81